/* eslint-disable tailwindcss/no-custom-classname -- This file uses dynamic attributes for the grid */

import {CELL_CLASSES, CELL_COMMON_CLASSES, SIDE_CLASSES} from 'slices/AffiliatesBanner/constants'

export const SideEdges = ({side}: {side: 'left' | 'right'}) => {
  const elements = new Array(3).fill(null)

  return elements.map((_, index) => (
    <div
      key={`${side}-${index}`}
      className={`
        ${SIDE_CLASSES[side]}
        row-start-${index + 1}
        ${CELL_COMMON_CLASSES} ${CELL_CLASSES[index]}
        `}
    />
  ))
}

export const Separators = ({length}: {length: number}) => {
  const cols = length - 1
  const rows = 3

  const elements = Array.from({length: cols}, (_, colIdx) =>
    Array.from({length: rows}, (__, rowIdx) => ({
      colStart: colIdx * 2 + 3,
      rowStart: rowIdx + 1,
    })),
  ).flat()

  return (
    <>
      {elements.map(({colStart, rowStart}, index) => (
        <div
          key={`separator-${index}`}
          id={index.toString()}
          className={`${CELL_COMMON_CLASSES} row-start-${rowStart} col-start-${colStart} ml-[-1px] ${
            rowStart === 0 ? '' : 'mt-[-1px]'
          }`}
        />
      ))}
    </>
  )
}
